var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C3 12.88 3 24.76 3 37 C1.515 37.495 1.515 37.495 0 38 C-1.9375 36.671875 -1.9375 36.671875 -4 34.75 C-4.680625 34.12609375 -5.36125 33.5021875 -6.0625 32.859375 C-8 31 -8 31 -9.42578125 29.30859375 C-11.62011829 27.48451705 -13.3723844 27.49529971 -16.1875 27.3125 C-18.5696875 27.1578125 -18.5696875 27.1578125 -21 27 C-21 21.72 -21 16.44 -21 11 C-19.535625 11.020625 -18.07125 11.04125 -16.5625 11.0625 C-10.45844797 10.51547969 -7.74822002 7.47299116 -3.8125 3.03125 C-2 1 -2 1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(29,13)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.29110203 0.77805149 9.7900212 4.52233468 14 9 C18.15090116 15.28924418 17.73331145 22.71745871 17 30 C15.3307247 36.55111817 10.60576399 41.39853151 5 45 C2.24609375 45.69140625 2.24609375 45.69140625 0 46 C-0.33 44.35 -0.66 42.7 -1 41 C-0.46890625 40.64808594 0.0621875 40.29617187 0.609375 39.93359375 C5.32387119 36.63860827 9.23822631 33.63989187 11 28 C11.82206717 22.05654887 11.53345106 17.01522086 8 12 C5.24768779 9.29228544 2.46821795 6.73410897 -1 5 C-0.67 3.35 -0.34 1.7 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(39,9)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 6.25 2.9375 C8.73603607 7.28806313 8.94570603 11.09952329 8 16 C6.57211893 18.50496783 5.1198641 19.9861291 3 22 C2.01 21.67 1.02 21.34 0 21 C0 14.07 0 7.14 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(36,21)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/volume_up.800d936947135a7b481d0dbba1909422.svg";
export { ForwardRef as ReactComponent };